import type { HovAmplifierEntrySnapshot } from "./hovAmplifierModel";

export type AmplifierSnapshotUpgradeState = "ready" | "shortage" | "locked";

export function computeAmplifierSnapshotUpgradeState(
  entry: HovAmplifierEntrySnapshot | null,
): AmplifierSnapshotUpgradeState {
  if (entry === null || !entry.unlocked) return "locked";
  if (entry.canPurchaseUpgrade) return "ready";
  return "shortage";
}
